"use client"

import { Toaster as Sonner, type ToasterProps } from "sonner"

/**
 * Sonner Toaster component configured for the app's theme.
 * Mount this once at the app root level to enable toasts from anywhere.
 *
 * @param props - Sonner ToasterProps for customization.
 * @returns The Sonner Toaster element.
 */
function Toaster({ ...props }: ToasterProps): React.JSX.Element {
  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:relative",
          closeButton:
            "!absolute !top-2 !right-2 !left-auto !transform-none !border-none !bg-transparent !text-muted-foreground hover:!text-foreground",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
